import { memo } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
const PrimaryMessageFooter = ({
  children
}) => {
  return /*#__PURE__*/_jsx(Flex, {
    "data-test-id": "primary-message-footer",
    marginBlockStart: "100",
    children: children
  });
};
PrimaryMessageFooter.displayName = 'PrimaryMessageFooter';
export default /*#__PURE__*/memo(PrimaryMessageFooter);